export const STATUS_TYPE = {
  0: { text: '未审核', color: 'info' },
  1: { text: '审核通过', color: 'success' },
  3: { text: '审核不通过', color: 'danger' },
  '-1': { text: '黑名单', color: 'info' }
};

export const PAGINATION = {
  page: 1,
  size: 25
};

export const ALL_DEPOSIT_ENSURED = {
  true: { text: '都已确认', color: 'success' },
  false: { text: '有未确认或异常', color: 'danger' }
};
